<template>
    <iframe ref="extral-page" id="thirdIframe" :src="_refUrl" class="docframe width-p100" seamless :style="{ height: this.containerHeight }"></iframe>
</template>
<script>
import { mapGetters } from 'vuex'
// 用于自定义菜单节点
export default {
    name: `LayoutExtralPage`,
    data() {
        return {
            title: `打开第三方页面`,
            refUrl: this.$route.query.source,
            token: this.$route.query.token,
            surgeryId: this.$route.query.surgery_id,
            surgeryInfo: {},
            from: this.$route.query.from,
            extralPageUrlMode: this.$root.ExtralPageUrlMode,
            isKbIndex: this.$route.fullPath && _.includes(this.$route.fullPath, `kb_index`),
            visitInfo: {}
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
            this.$store.dispatch(`ADD_WARD_AUTH`)
        }
        this.loadSurgery()
    },
    computed: {
        ...mapGetters([`screenHeight`, `ward_auth`, `currentUser`, `permissions`, `active_ward`]),
        containerHeight() {
            return `${this.screenHeight - 120}px`
        },
        _refUrl() {
            if (!this.refUrl) return null
            let refUrl = this.refUrl
            if (this.from != `google`) {
                refUrl = decodeURIComponent(refUrl)
            }
            let jmType = ``
            if (refUrl.indexOf(`base64_utf8`) != -1) {
                jmType = `|base64_utf8`
            }
            if (this.currentUser) {
                _.each(this.currentUser, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
                if (this.isKbIndex) {
                    if (this.currentUser.username) {
                        let paraobj = {
                            user_name: this.currentUser.username,
                            worker_name: this.currentUser.dic_worker_name,
                            kb_index: _.find(this.permissions, { no: `kb_index` }) != undefined,
                            kb_clinic: _.find(this.permissions, { no: `kb_clinic` }) != undefined,
                            kb_announcements: _.find(this.permissions, { no: `kb_announcements` }) != undefined,
                            kb_requirement: _.find(this.permissions, { no: `kb_requirement` }) != undefined,
                            kb_add: _.find(this.permissions, { no: `kb_add` }) != undefined,
                            kb_edit: _.find(this.permissions, { no: `kb_edit` }) != undefined,
                            kb_delete: _.find(this.permissions, { no: `kb_delete` }) != undefined
                        }
                        let para = JSON.stringify(paraobj)
                        refUrl = refUrl.replace(`@para` + jmType, jmType == `` ? para : window.btoa(unescape(encodeURIComponent(para))))
                        refUrl += `&id=kb`
                    } else {
                        return null
                    }
                }
            } else if (this.isKbIndex) {
                return null
            }

            if (this.visitInfo) {
                _.each(this.visitInfo, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            if (this.surgeryInfo) {
                _.each(this.surgeryInfo, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            if (this.extralPageUrlMode == `1` && !_.includes(refUrl, `doccenter`)) {
                if (refUrl.indexOf(`?`) > -1) {
                    let refstr = refUrl.split(`?`)
                    refUrl = refstr[0] + `?` + encodeURIComponent(refUrl.replace(refstr[0] + `?`, ``))
                }
            }
            if (refUrl.indexOf(`@QcsPermissions`) > -1) {
                let qcsPermissions = _.filter(this.permissions, function(o) {
                    return o.permission && o.permission.indexOf(`qcper_`) > -1
                })
                let qcsPermissionString = _.join(qcsPermissions.map(p => p.no), `,`)
                refUrl = refUrl.replace(`@QcsPermissions`, qcsPermissionString)
            }
            // 区域获取
            if (refUrl.indexOf(`@deptnos`) > -1 && this.ward_auth) {
                console.log(`this.ward_auth`)
                console.log(this.ward_auth)
                var ows = _.filter(this.ward_auth, function(o) {
                    return o.value && _.includes(o.value, `ow_`)
                })
                var owids = ``
                _.each(ows, ow => {
                    owids += ow.origion + `,`
                })
                owids = owids.slice(0, -1)
                refUrl = refUrl.replace(`@deptnos`, owids)
            }
            if (refUrl.indexOf(`@operatingWardId`) > -1 && this.active_ward && this.active_ward.value) {
                let operatingWardId = this.active_ward && this.active_ward.value.split(`_`)[1]
                refUrl = refUrl.replace(`@operatingWardId`, operatingWardId)
            }
            if (refUrl.indexOf(`@currentdeptno`) > -1 && this.active_ward && this.active_ward.value) {
                let operatingWardId = this.active_ward && this.active_ward.value.split(`_`)[1]
                refUrl = refUrl.replace(`@currentdeptno`, operatingWardId)
            }
            console.log(this.visitInfo)
            console.log(refUrl)
            return refUrl
        }
    },
    methods: {
        isjson(jsonstr) {
            if (typeof jsonstr == `string`) {
                try {
                    var obj = JSON.parse(jsonstr)
                    if (typeof obj == `object` && obj) {
                        return true
                    } else {
                        return false
                    }
                } catch (e) {
                    return false
                }
            }
            return false
        },
        loadSurgery() {
            if (!this.surgeryId) {
                this.surgeryInfo = {}
                this.visitInfo = {}
                return
            }
            var that = this
            this.myaxios
                .get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
                .then(data => {
                    let extrDatas = _.reduce(data.extra_datas, function(result, value, index) {
                        let flag = that.isjson(value.DataValue)
                        if (value.DataValue != `` && flag == true) {
                            result[value.DataKey] = value.DataExtraValue
                        } else {
                            result[value.DataKey] = value.DataValue
                        }
                        return result
                    }, {})
                    this.surgeryInfo = Object.assign(data, extrDatas)
                    this.visitInfo = data.visit_info
                })
                .then(data => {
                    // ACIS-23927手麻系统集成360全息视图
                    if (this.refUrl.slice(0, 4) != `http` && this.refUrl.indexOf(`carte_`) != -1) {
                        let refUrl = this.refUrl
                        let jmType = ``
                        if (refUrl.indexOf(`base64_utf8`) != -1) {
                            jmType = `|base64_utf8`
                        }
                        if (this.currentUser) {
                            _.each(this.currentUser, (value, key) => {
                                refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                            })
                        }

                        if (this.visitInfo) {
                            _.each(this.visitInfo, (value, key) => {
                                refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                            })
                        }
                        if (this.surgeryInfo) {
                            _.each(this.surgeryInfo, (value, key) => {
                                refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                            })
                        }

                        let type = refUrl.split(`?`)[0]
                        let paramStr = refUrl.split(`?`)[1]
                        let req = this.myaxios.post(`/api/Anonymous/Carte/RunCarteServer?type=${type}&paramStr=${paramStr}`)
                        req.then(data => {
                            this.refUrl = data
                        }).catch(e => {
                            console.log(e)
                        })
                    }
                })
                .catch(e => {
                    console.log(e)
                })
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.refUrl = newUrl.query.source
            this.loadSurgery()
        }
    }
}
</script>

<style scoped>
.docframe {
    border: none;
    background: #c0c4cc;
}
</style>



// WEBPACK FOOTER //
// src/components/LayoutExtralPage.vue